import {
  PlantRequest,
  UpdatePlantRequest,
  UpdatePlantStatusRequest,
} from '../../interface/request/PlantRequest'

import { GenericAPIResponse } from '../../interface/response/CommonResponse'
import { PlantData, PlantInfo } from '../../interface/response/PlantResponse'
import { ProductData } from '../../interface/response/ProductResponse'
import { apiService } from '../apiService'

export const plantApiService = apiService.injectEndpoints({
  endpoints: (builder) => ({
    getPlants: builder.query({
      query: (args: object) => {
        return {
          url: `/Plant/GetPlants`,
          params: args,
        }
      },
      transformResponse: (response: { data: PlantData[] }) => {
        return response?.data
      },
      providesTags: ['PlantList'],
    }),
    getPlantDetailsByCode: builder.query({
      query: (PlantCode: string) => {
        return {
          url: `/Plant/GetPlantDetailsByCode`,
          params: {
            PlantCode: PlantCode,
          },
        }
      },
      transformResponse: (response: { data: PlantInfo }) => {
        return response?.data
      },
      providesTags: ['GetPlantByCode'],
    }),
    getProducts: builder.query({
      query: () => {
        return {
          url: `/Plant/GetProducts`,
        }
      },
      transformResponse: (response: { data: ProductData[] }) => {
        return response?.data
      },
      providesTags: ['ProductList'],
    }),
    addPlant: builder.mutation({
      query: (queryData: PlantRequest) => {
        return {
          url: `/Plant/createPlant`,
          method: 'POST',
          body: queryData,
        }
      },
      invalidatesTags: ['PlantList'],
      transformResponse: (response: GenericAPIResponse) => {
        return response
      },
    }),
    updatePlant: builder.mutation({
      query: (queryData: UpdatePlantRequest) => {
        return {
          url: `/Plant/UpdatePlant`,
          method: 'POST',
          body: queryData,
        }
      },
      invalidatesTags: ['PlantList', 'GetPlantByCode'],
      transformResponse: (response: GenericAPIResponse) => {
        return response
      },
    }),
    updatePlantStatus: builder.mutation({
      query: (queryData: UpdatePlantStatusRequest) => {
        return {
          url: `/Plant/UpdatePlantStatus`,
          method: 'POST',
          body: queryData,
        }
      },
      invalidatesTags: ['PlantList', 'GetPlantByCode'],
      transformResponse: (response: GenericAPIResponse) => {
        return response
      },
    }),
  }),
})

export const {
  useLazyGetPlantsQuery,
  useLazyGetPlantDetailsByCodeQuery,
  useLazyGetProductsQuery,
  useAddPlantMutation,
  useUpdatePlantMutation,
  useUpdatePlantStatusMutation,
} = plantApiService
